import { Component } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { LookAheadItemComponent } from '../look-ahead-item.component';
import { SubmissionStakeholder } from '../../../../../../../models/submissions/member-submission';
import { map } from 'rxjs/operators';
import { ThrottleClickDirective } from '../../../../../../../directives/throttle-click.directive';
import { UserProfileBadgeComponent } from '../../../../user-profile-badge/user-profile-badge.component';

@Component({
  selector: 'app-profile-look-ahead-item',
  standalone: true,
  imports: [NgClass, AsyncPipe, MatRippleModule, NgbTooltip, ThrottleClickDirective, UserProfileBadgeComponent],
  templateUrl: './profile-look-ahead-item.component.html',
  styleUrls: ['./profile-look-ahead-item.component.scss', '../look-ahead-item.component.scss']
})
export class ProfileLookAheadItemComponent extends LookAheadItemComponent {
  constructor() {
    super();
  }

  private getItemAsSubmissionStakeHolder$ = this.item$.pipe(map(i => i as SubmissionStakeholder));

  public initials$ = this.getItemAsSubmissionStakeHolder$.pipe(map(i => i.initials));
  public profileBadgeConfiguration$ = this.getItemAsSubmissionStakeHolder$.pipe(map(i => i.profileBadgeConfiguration));
}
